// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9335d5d8","453":"466679a6","644":"5c9b2848","732":"9ec65d8f"}[chunkId] + ".chunk.js";
};